export const defaultChannelId = 1;
export const defaultRegionIndex = 0; // index in list of regions
export const defaultQualityIndex = 1; // index in list of quality
export const playerRecoveryPause = 3; // in seconds
export const text = {
  "Change region": "Змінити регіон",
};
